<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="12">
        <UserOptions
          ref="userOptions"
          :roleID="roleID"
          @reload="$refs.userTable.getData()"
        />
      </el-col>
      <el-col :span="12">
        <UserTable
          ref="userTable"
          :roleID="roleID"
          @reload="$refs.userOptions.getData()"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import UserTable from './user-table'
import UserOptions from './user-options'
export default {
  components: { UserTable, UserOptions },
  props: { roleID: { type: String, default: '' } },
}
</script>

<style scoped></style>
